import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const createStandaloneSchemePortal = async (data) => {
  const res = await axiosInstance.post(
    "/standalone-marks-portal/schemes/create",
    data
  );
  return res.data;
};

export const getAllStandaloneSchemesPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/schemes/all${qs(filters)}`
  );
  return res.data;
};

export const getStandaloneSchemeByIdPortal = async (id) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/schemes/${id}`
  );
  return res.data;
};

export const updateStandaloneSchemePortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/standalone-marks-portal/schemes/update/${id}`,
    data
  );
  return res.data;
};

export const deleteStandaloneSchemePortal = async (id) => {
  const res = await axiosInstance.delete(
    `/standalone-marks-portal/schemes/delete/${id}`
  );
  return res.data;
};

export const getTeachersForStandalonePortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/teachers${qs(filters)}`
  );
  return res.data;
};

export const createStandaloneAssignmentPortal = async (data) => {
  const res = await axiosInstance.post(
    "/standalone-marks-portal/assign",
    data
  );
  return res.data;
};

export const getAllStandaloneAssignmentsPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/assignments/all${qs(filters)}`
  );
  return res.data;
};

export const updateStandaloneAssignmentStatusPortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/standalone-marks-portal/assignments/status/${id}`,
    data
  );
  return res.data;
};

export const getMyStandaloneAssignments = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/my-assignments${qs(filters)}`
  );
  return res.data;
};

export const getStandaloneEntryPortal = async (assignmentId) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/entry/${assignmentId}`
  );
  return res.data;
};

export const saveStandaloneEntryPortal = async (data) => {
  const res = await axiosInstance.post(
    "/standalone-marks-portal/entry/save",
    data
  );
  return res.data;
};

export const submitStandaloneEntryPortal = async (assignmentId) => {
  const res = await axiosInstance.post(
    `/standalone-marks-portal/entry/submit/${assignmentId}`
  );
  return res.data;
};

export const getStandaloneEntriesPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks-portal/entries${qs(filters)}`
  );
  return res.data;
};
